import { PlainText } from './plain-text';
import { Statistics } from './statistics-card';
import { Topic } from './topic/topic-card';

import { AskSynclyAnswerType } from '@/entities/ask-syncly/ask-syncly-constants';
import type { IAnswer } from '@/entities/ask-syncly/ask-syncly-types';

export const ComponentMapper = (props: {
  session_id: string;
  answer: IAnswer;
  block_id: string;
}) => {
  switch (props.answer.type) {
    case AskSynclyAnswerType.STATISTICAL_ANALYSIS:
      return <Statistics {...props.answer.content} />;
    case AskSynclyAnswerType.TOPIC_ANALYSIS:
      return (
        <Topic
          session_id={props.session_id}
          answer={props.answer.content}
          block_id={props.block_id}
        />
      );
    case AskSynclyAnswerType.PLAIN_TEXT:
      return <PlainText {...props.answer.content} />;
  }
};
